import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
export interface ScoreReportDownloadListTableState {
    TableState: string;
}

// Define the initial state using that type
const initialState: ScoreReportDownloadListTableState = {
    TableState: JSON.stringify({ sorting: { sortModel: [{ field: "name", sort: "asc" }] } }),
};

export const scoreReportDownloadListTableStateSlice = createSlice({
    name: "scoreReportDownloadListTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateScoreReportDownloadGridState: (state, action: PayloadAction<string | null>) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateScoreReportDownloadGridState } =
    scoreReportDownloadListTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const scoreReportDownloadListTableState = (state: RootState) => state;
export default scoreReportDownloadListTableStateSlice.reducer;
